import React from 'react';
import PageShell from '../Components/ui/PageShell';
import MySourcedProfilesPanel from '../Components/profiles/MySourcedProfilesPanel';

function MySourcedProfilesPage() {
  return (
    <PageShell
      title="My Sourced Profiles"
      subtitle="View profiles you uploaded and jump directly to the related requirement."
      breadcrumbs={[
        { label: 'Dashboard', path: '/dashboard' },
        { label: 'My Sourced Profiles' },
      ]}
      backTo="/dashboard"
    >
      <MySourcedProfilesPanel />
    </PageShell>
  );
}

export default MySourcedProfilesPage;
